import logger from "@/configs/logger";

export const Twilio = require("twilio-client");

export class TwilioClient {
  device!: any;

  constructor() {
    this.device = new Twilio.Device();
  }

  setup(token: string) {
    logger("log", "Setting up twilio");
    return this.device.setup(token, {
      debug: true,
      closeProtection: true,
      enableIceRestart: true,
      allowIncomingWhileBusy: true
      //enableRingingState: true
    });
  }
}

export default new TwilioClient();
